var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpLoadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_68",
    d: "M17.4667 11.7338L13.5152 7.78947V17.1422H10.4848V7.78947L6.53333 11.7338L4.38788 9.59226L12 2L19.6121 9.59831L17.4667 11.7338ZM5.0303 13.2281H2V22H22V13.2281H18.9697V18.9752H5.0303V13.2281Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpLoadIcon);
export default __webpack_public_path__ + "static/media/upLoad_icon.64c741c1eb5bb32cbf5ce8b7d3503635.svg";
export { ForwardRef as ReactComponent };